import React from "react";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import type { DevToolsPlugin } from "../../types";
import { Accordion } from "../../Accordion";

interface Site {
  name: string;
  description: string;
  href: string;
}

interface SitesPluginProps {
  mainSites: Site[];
  ukSites: Site[];
  usSites: Site[];
  verticals: Record<string, string>;
}

function SitesPanel({ mainSites, ukSites, usSites, verticals }: SitesPluginProps) {
  const verticalEntries = Object.entries(verticals);
  return (
    <>
      <Accordion title="Main Sites" count={mainSites.length}>
        <div className="dt-chip-grid">
          {mainSites.map((site) => (
            <a key={site.name} className="dt-chip" href={site.href}>{site.description}</a>
          ))}
        </div>
      </Accordion>

      {ukSites.length > 0 && (
        <Accordion title="UK Partners" count={ukSites.length}>
          <div className="dt-chip-grid">
            {ukSites.map((site) => (
              <a key={site.name} className="dt-chip" href={site.href}>{site.description}</a>
            ))}
          </div>
        </Accordion>
      )}

      {usSites.length > 0 && (
        <Accordion title="US Partners" count={usSites.length}>
          <div className="dt-chip-grid">
            {usSites.map((site) => (
              <a key={site.name} className="dt-chip" href={site.href}>{site.description}</a>
            ))}
          </div>
        </Accordion>
      )}

      <Accordion title="Verticals" count={verticalEntries.length}>
        <div className="dt-chip-grid">
          {verticalEntries.map(([name, href]) => (
            <a key={name} className="dt-chip" href={href}>{name}</a>
          ))}
        </div>
      </Accordion>
    </>
  );
}

export function sitesPlugin(props: SitesPluginProps): DevToolsPlugin {
  return {
    id: "sites",
    name: "Sites & Verticals",
    icon: faGlobe,
    render: () => <SitesPanel {...props} />,
  };
}
